import type { StoredKeycloakTokens } from "./keycloakCapacitorTokenStorage.js";

// Tab-scoped on purpose: the tokens of a device-grant sign-in belong to the
// onboarding PC's tab and must vanish when it closes.
const STORAGE_KEY = "device-grant-tokens";

function isStoredTokens(value: unknown): value is StoredKeycloakTokens {
  if (typeof value !== "object" || value === null) return false;
  const v = value as Record<string, unknown>;
  if (typeof v.token !== "string" || v.token.length === 0) return false;
  if (typeof v.refreshToken !== "string" || v.refreshToken.length === 0)
    return false;
  if (v.idToken !== undefined && typeof v.idToken !== "string") return false;
  return true;
}

export const deviceGrantTokenStorage = {
  read(): StoredKeycloakTokens | null {
    try {
      const value = sessionStorage.getItem(STORAGE_KEY);
      if (!value) return null;
      const parsed: unknown = JSON.parse(value);
      return isStoredTokens(parsed) ? parsed : null;
    } catch {
      return null;
    }
  },

  has(): boolean {
    return deviceGrantTokenStorage.read() !== null;
  },

  /** Returns whether the entry was stored. */
  write(tokens: StoredKeycloakTokens): boolean {
    try {
      sessionStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({
          token: tokens.token,
          refreshToken: tokens.refreshToken,
          ...(tokens.idToken ? { idToken: tokens.idToken } : {}),
        })
      );
      return true;
    } catch {
      // Storage blocked: the caller decides how to tell the user.
      return false;
    }
  },

  clear(): void {
    try {
      sessionStorage.removeItem(STORAGE_KEY);
    } catch {
      // Nothing to clear when storage is unavailable.
    }
  },
};
